<template>
  <ItemTableActionBarHeaderMessage
    level="error"
    linkText="view"
    message="- Invalid Service Accounts"
    messageHeader="MacOS Issues"
  >
    <ButtonLink
      data-test-id="SecureTokenRemediationBanner_link"
      text="view"
      @click="handleClick()"
    />
  </ItemTableActionBarHeaderMessage>
</template>

<script>
import {
  ButtonLink,
} from '@jumpcloud/ui-components';
import ItemTableActionBarHeaderMessage from 'client/components/ItemTable/ItemTableActionBarHeaderMessage.vue';

export default {
  name: 'SecureTokenRemediationBanner',

  components: {
    ButtonLink,
    ItemTableActionBarHeaderMessage,
  },

  methods: {
    async handleClick() {
      this.$emit('click', 1);
    },
  },
};
</script>

<style>
</style>
